import { useEffect, useRef, useState } from "react";
import { Link, Navigate, useParams, useSearchParams } from "react-router-dom";
import { dictionaries, I18nContext, type Lang } from "@/lib/i18n";
import { postForm } from "@/lib/api";

export default function Unsubscribe() {
  const { lang } = useParams();
  const [params] = useSearchParams();
  const valid = lang === "en" || lang === "tr";
  const t = valid ? dictionaries[lang as Lang] : dictionaries.en;
  const [state, setState] = useState<"working" | "done" | "invalid">("working");
  const fired = useRef(false);

  useEffect(() => {
    if (!valid || fired.current) return;
    fired.current = true;
    document.documentElement.lang = lang as string;
    document.title = t.meta.title;
    postForm("/newsletter/unsubscribe", {
      token: params.get("token") ?? "",
    }).then((r) => setState(r.ok ? "done" : "invalid"));
  }, [valid, lang, t, params]);

  if (!valid) return <Navigate to="/en" replace />;

  return (
    <I18nContext.Provider value={t}>
      <div className="flex min-h-svh flex-col items-center justify-center bg-if-black px-6 font-sans text-if-text antialiased">
        <span className="inline-block h-1.5 w-1.5 rotate-45 bg-if-gold" />
        <p className="mt-8 text-[11px] font-medium uppercase tracking-[0.35em] text-if-text">
          {t.brand.name}
        </p>
        <p
          data-testid="unsubscribe-state"
          className={`mt-10 max-w-md text-center text-sm font-light leading-relaxed ${
            state === "done" ? "text-if-gold" : "text-if-dim"
          }`}
        >
          {state === "working"
            ? t.unsubscribe.working
            : state === "done"
              ? t.unsubscribe.success
              : t.unsubscribe.invalid}
        </p>
        <Link
          to={`/${lang}`}
          data-testid="unsubscribe-home-link"
          className="mt-12 text-[10px] uppercase tracking-[0.3em] text-if-dim transition-colors duration-300 hover:text-if-gold"
        >
          {t.unsubscribe.home}
        </Link>
      </div>
    </I18nContext.Provider>
  );
}
